export const REFRESHED_ENTITIES = [
  'bobjectFields',
  'bobjectPicklistFieldValues',
  'bobjectGlobalPicklists',
];
